import { render } from "./S272833.vue?vue&type=template&id=542ad1fc"
const script = {}
script.render = render

export default script